import { toDate as o } from "./toDate.js";
function e(t) {
  return +o(t) < Date.now();
}
export {
  e as default,
  e as isPast
};
